<template>
  <div class="centerx sidebar">
    <vs-sidebar
      :click-not-close="true"
      position-right
      parent="body"
      default-index="0"
      :class="this.className"
      v-model="active"
    >
      <div v-html="this.content" id="side_bar_cont" class="content"></div>
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      content: "",
      className: "",
    };
  },

  /* ✅ AGGIUNTO: ascolto evento globale + ESC */
  mounted() {
    // chiudi quando qualcuno emette l’evento globale
    this.__onSidebarClose = () => this.closeSidebar();
    window.addEventListener('sidebar:close', this.__onSidebarClose);

    // chiudi su tasto ESC
    this.__onKeydown = (e) => {
      if (e && (e.key === 'Escape' || e.keyCode === 27)) {
        this.closeSidebar();
      }
    };
    window.addEventListener('keydown', this.__onKeydown);
  },

  /* ✅ AGGIUNTO: pulizia listener */
  beforeDestroy() {        // Vue 2
    window.removeEventListener('sidebar:close', this.__onSidebarClose);
    window.removeEventListener('keydown', this.__onKeydown);
  },
  methods: {
    renderDom() {
      window.setTimeout(() => {
        var divP = document.getElementById("side_bar_cont");
        divP.innerHTML = "";
        var div = document.createElement("div");
        div.id = "vuejs-render";
        divP.appendChild(div);
        var tmp = Vue.extend({
          template: this.content,
        });
        new tmp().$mount(div);
        this.attachCloseButton();
        $('[data-toggle="tooltip"]').tooltip();
        $(".js-example-basic").select2();

        app.__vue__.disabledWithoutPermission();

        if (window.Livewire) {
          window.Livewire.rescan();
        } else {
           // nel raro caso in cui gli script non siano ancora pronti
          document.addEventListener('livewire:load', () => window.Livewire.rescan(), { once: true });
        }
        
      }, 100);
    },

attachCloseButton() {
  const wrapper = document.getElementById("side_bar_cont");
  if (!wrapper) return;

  // 1) Se esiste già un close “desktop”, NON creiamo un doppione.
  //    Metti qui eventuali selettori del tuo bottone di chiusura esistente.
  const existingClose = wrapper.querySelector(
    '[data-sidebar-internal-close], .sidebar-close, .btn[data-dismiss="sidebar"], .btn-close'
  );

  if (existingClose) {
    // opzionale: aggancia il nostro handler per coerenza
    existingClose.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeSidebar();
    }, { once: false });
  } else {
    // 2) Crea un close **desktop** (solo se non ne esiste già uno)
    const desktopBtn = document.createElement("button");
    desktopBtn.type = "button";
    desktopBtn.className = "btn bg-transparent d-none d-sm-inline-flex";
    desktopBtn.innerHTML = "<i class='fas fa-times'></i>";
    desktopBtn.setAttribute("aria-label", "Chiudi");
    desktopBtn.addEventListener("click", () => this.closeSidebar());
    
    const desktopSlot = document.createElement("div");
    desktopSlot.className = "close-sidebar-container";
    desktopSlot.appendChild(desktopBtn);
    // Inseriamo in cima al contenuto
    wrapper.insertBefore(desktopSlot, wrapper.firstChild);
  }

  // 3) Crea SEMPRE un close **mobile** (visibile solo <576px)
  //    Così abbiamo la X anche quando il contenuto non la prevede.
  const mobileBtn = document.createElement("button");
  mobileBtn.type = "button";
  mobileBtn.className = "btn bg-transparent d-sm-none";
  mobileBtn.innerHTML = "<i class='fas fa-times'></i>";
  mobileBtn.setAttribute("aria-label", "Chiudi");
  mobileBtn.addEventListener("click", () => this.closeSidebar());

  const mobileSlot = document.createElement("div");
  mobileSlot.className = "close-sidebar-container";
  mobileSlot.appendChild(mobileBtn);

  // Se in cima c'è già un nostro container, evita di duplicarlo
  const firstContainer = wrapper.querySelector(".close-sidebar-container");
  if (firstContainer) {
    // Se c'è già (es. desktop), aggiungi il mobile dentro lo stesso contenitore
    firstContainer.appendChild(mobileBtn);
  } else {
    wrapper.insertBefore(mobileSlot, wrapper.firstChild);
  }
},


    closeSidebar() {
      if (app.__vue__.$refs) {
        for (let ref in app.__vue__.$refs) {
          if (ref.includes("vuetable")) {
            var params = {
              ref: ref,
              page: 1,
              itemId: null,
            };
            params = app.__vue__.$refs[ref].prepareDataVueTableOptions(params);
            app.__vue__.setVueTableOptions(params);
            break;
          }
        }
      }

      // chiudi davvero la vs-sidebar
      this.active = false;
      document.body.style.overflow = '';

      // ripulisci eventuale hash dall’URL
      var url = window.location.href.replace(/#.*$/, "");
      history.replaceState(null, null, url);

    },
    toggle(urlBody, className = "") {
      let dataSidebar = this;
      this.className += " " + className;
      app.__vue__.appendLoader();
      axios.get(urlBody).then(function (response) {
        let tempElement = document.createElement('div');
        tempElement.innerHTML = response.data;
        dataSidebar.content = tempElement.innerHTML;
        dataSidebar.renderDom();
        window.setTimeout(() => {
          dataSidebar.active = true;
          document.body.style.overflow = 'hidden';
          $(".tabs-component li a").click(function (e) {
            e.preventDefault();
          });
        }, 100);
        app.__vue__.removeLoader();
      });
    },

    /* ✅ (facoltativo) alias "close" per coerenza API */
    close() {
      this.closeSidebar();
    },
  },
};
</script>

<style scoped>
:deep(.vs-sidebar.vs-sidebar-primary.vs-sidebar-position-right) {
  max-width: 440px;
  padding: 10px;
}
</style>
